"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getActiveElement = exports.isElementPseudoFocused = exports.focusElement = exports.getFocusableElements = exports.isElementFocusable = void 0;
/**
 * Data attribute for handling pseudo focus
 * when focus stays on the input but arrow keys navigated dropdown items
 */
var pseudoFocusAttribute = "data-bui-focus";
var focusableSelector = "\n  a,button,details,\n  input:not([type=\"hidden\"]),textarea,select,iframe,\n  [tabindex]:not([tabindex=\"-1\"])";
var isElementFocusable = function (el, options) {
    var isValid = !el.hasAttribute("disabled") &&
        // Checking that element is not rendered inside a display: none wrapper
        // Using getBoundingClientRect works for inline elements, while clientHeight doesn't
        (el.getBoundingClientRect().height > 0 || el instanceof HTMLInputElement) &&
        !(el.hasAttribute("tabindex") && el.getAttribute("tabindex") === "-1");
    if (options === null || options === void 0 ? void 0 : options.matchSelector) {
        isValid = el.matches(focusableSelector);
    }
    return isValid;
};
exports.isElementFocusable = isElementFocusable;
var getFocusableElements = function (el, additionalEl) {
    var focusableElements = Array.from(el.querySelectorAll(focusableSelector));
    var filteredElements = focusableElements.filter(function (el) {
        return (0, exports.isElementFocusable)(el);
    });
    if (filteredElements.length && additionalEl) {
        filteredElements.unshift(additionalEl);
    }
    return filteredElements;
};
exports.getFocusableElements = getFocusableElements;
var focusElement = function (el, options) {
    var _a;
    (_a = document
        .querySelector("[".concat(pseudoFocusAttribute, "]"))) === null || _a === void 0 ? void 0 : _a.removeAttribute(pseudoFocusAttribute);
    if (options === null || options === void 0 ? void 0 : options.pseudoFocus) {
        el.setAttribute(pseudoFocusAttribute, "true");
    }
    else {
        el.focus();
    }
};
exports.focusElement = focusElement;
var isElementPseudoFocused = function (el) {
    return el.hasAttribute(pseudoFocusAttribute);
};
exports.isElementPseudoFocused = isElementPseudoFocused;
var getActiveElement = function () {
    var pseudoFocusedEl = document.querySelector("[".concat(pseudoFocusAttribute, "]"));
    return (pseudoFocusedEl || document.activeElement);
};
exports.getActiveElement = getActiveElement;
